import { application } from 'services/core'

function SubscriptionManagementPanel () {
  // Add Js when required
}

application.register(SubscriptionManagementPanel, import.meta)
export default SubscriptionManagementPanel
